import { render, staticRenderFns } from "./WebShopCategoryModal.vue?vue&type=template&id=fdb77476&scoped=true&"
import script from "./WebShopCategoryModal.vue?vue&type=script&lang=js&"
export * from "./WebShopCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb77476",
  null
  
)

export default component.exports